// extracted by mini-css-extract-plugin
module.exports = {"showLabelFavoriteButton":"FavoriteButtonLegacy_showLabelFavoriteButton__J9_fx","notShowLabelFavoriteButton":"FavoriteButtonLegacy_notShowLabelFavoriteButton__Z6bcP"};